import { render, staticRenderFns } from "./AllContactsBrowse.vue?vue&type=template&id=1557f2f2"
import script from "./AllContactsBrowse.vue?vue&type=script&lang=ts"
export * from "./AllContactsBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1557f2f2')) {
      api.createRecord('1557f2f2', component.options)
    } else {
      api.reload('1557f2f2', component.options)
    }
    module.hot.accept("./AllContactsBrowse.vue?vue&type=template&id=1557f2f2", function () {
      api.rerender('1557f2f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/AllContactsBrowse.vue"
export default component.exports